import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, TextField, Typography } from "@mui/material";


export default function SellerDealOptoutDialog(props) {
	const [form, setForm] = useState({ confirm: "" });
	const [disabled, setDisabled] = useState(true);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		//console.log(form.confirm, form.confirm === "supprimer " + state.name);
		setDisabled(!(form.confirm === "supprimer"));
	}, [form]);
	const handleSubmitDeleteDealUser = () => {
		console.log("handleSubmitNewDeal");
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/8003959e92fc491aa03d8f7ee5aa4a4f/" + props.state.params.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.replace("/dashboardv/");
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog"><Typography variant="h5">Quitter le deal en tant que vendeur</Typography></DialogTitle>
			<DialogContent dividers>
				<Typography variant="h5" gutterBottom>
					Vous souhaitez vous retirer du deal ?
				</Typography>
				{props.state.params.ip && (
					<Typography variant="h5" gutterBottom>
						Vous êtes le vendeur référent
					</Typography>
				)}
				{props.state.params.ip && props.state.params.sellers.length === 0 && (
					<Typography variant="body1" gutterBottom>
						En l'absence d'autre vendeur, le dossier sera supprimé, (si vous souhaitez le transmettre, merci d'inviter cette personne
						avant de le supprimer??)
					</Typography>
				)}
				{props.state.params.ip && props.state.params.sellers.length > 0 && (
					<Fragment>
						<Typography variant="body1" gutterBottom>
							D'autres vendeurs existent, le dossier sera confié à l'un d'entre eux
						</Typography>
						<TextField
							id="next_owner"
							name="next_owner"
							select
							value={form.next_owner}
							onChange={handleChange}
							SelectProps={{
								native: true,
							}}
							variant="standard"
						>
							{" "}
							<option key={""} value={""}>
								<em>Choisir un nouveau référent</em>
							</option>
							{props.state.params.sellers.map((option) => (
								<option key={option.uid} value={option.uid}>
									{option.name}
								</option>
							))}
						</TextField>
					</Fragment>
				)}

				<Typography variant="body1" gutterBottom>
					Pour le supprimer, merci d'écrire la phrase "supprimer" en toutes lettres dans le champ ci-dessous
				</Typography>
				<div>
					<TextField
						id="confirm"
						name="confirm"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
						}}
						placeholder={"supprimer"}
						fullWidth
						margin="dense"
						size="small"
						value={form.confirm}
						onChange={handleChange}
					/>
				</div>
			</DialogContent>

			<DialogActions>
				<Button variant="outlined" onClick={handleClose}>
					Annuler
				</Button>
				<Button
					variant="contained"
					onClick={handleSubmitDeleteDealUser}
					disabled={disabled}
				>
					Supprimer
				</Button>
			</DialogActions>
		</Dialog>
	);
}
